/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MockERC1155Royalty,
  MockERC1155RoyaltyInterface,
} from "../MockERC1155Royalty";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_controlCenter",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "royaltyBps",
        type: "uint256",
      },
    ],
    name: "RoyaltyUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "royaltyBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_royaltyBps",
        type: "uint256",
      },
    ],
    name: "setRoyaltyBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type MockERC1155RoyaltyConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MockERC1155RoyaltyConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MockERC1155Royalty__factory extends ContractFactory {
  constructor(...args: MockERC1155RoyaltyConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _controlCenter: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MockERC1155Royalty> {
    return super.deploy(
      _controlCenter,
      overrides || {}
    ) as Promise<MockERC1155Royalty>;
  }
  getDeployTransaction(
    _controlCenter: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_controlCenter, overrides || {});
  }
  attach(address: string): MockERC1155Royalty {
    return super.attach(address) as MockERC1155Royalty;
  }
  connect(signer: Signer): MockERC1155Royalty__factory {
    return super.connect(signer) as MockERC1155Royalty__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockERC1155RoyaltyInterface {
    return new utils.Interface(_abi) as MockERC1155RoyaltyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockERC1155Royalty {
    return new Contract(address, _abi, signerOrProvider) as MockERC1155Royalty;
  }
}
